import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import MyContext from "../../context/Context";
import Loader from "../Loader/Loader";
import { deleteDoc, doc, setDoc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import toast from "react-hot-toast";

const ProductDetails = () => {

    const context = useContext(MyContext);
    const { loading, setLoading, getAllProduct, getAllProductFunction } = context;
    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();
    const handleDeleteClick = () => {
        setShowPopup(true);
    };

    // ✅ Delete Product
    const deleteProduct = async (id) => {
        setLoading(true);
        try {
            await deleteDoc(doc(fireDB, 'products', id));
            toast.success('Product deleted successfully');
            getAllProductFunction();
        } catch (error) {
            console.log(error);
            toast.error('Failed to delete product');
        }
        setLoading(false);
    };

    // ✅ Approve Product
    const approveProduct = async (id, product) => {
        setLoading(true);
        try {
            await setDoc(doc(fireDB, 'products', id), {
                ...product,
                approved: true, // ✅ Update approved status to true
            });
            toast.success('Product approved successfully');
            getAllProductFunction(); // Refresh product list after approval
        } catch (error) {
            console.log(error);
            toast.error('Failed to approve product');
        }
        setLoading(false);
    };



    // ✅ Approve Product
    const approveFeatured = async (id, product) => {
        setLoading(true);
        try {
            await setDoc(doc(fireDB, 'products', id), {
                ...product,
                featured: true, // ✅ Update featured status to true
            });
            toast.success('Product featured successfully');
            getAllProductFunction(); // Refresh product list after approval
        } catch (error) {
            console.log(error);
            toast.error('Failed to approve product');
        }
        setLoading(false);
    };



    return (

        <div>
            {/* Header */}
            <div className="py-5 flex justify-between items-center ">
                <h1 className="text-xl text-pink-300 font-bold">All Products</h1>
                <Link to="/addproduct">
                    <button className="cart-btn px-5 py-2 bg-pink-50 border border-pink-100 rounded-lg">
                        Add Product
                    </button>
                </Link>
            </div>

            {/* Loading */}
            {loading && (
                <div className="flex justify-center">
                    <Loader />
                </div>
            )}

            {/* Product Table */}
            <div className="w-full overflow-x-auto hide-scroll-bar mb-5">
                <table className="w-full text-center border-collapse sm:border-separate border border-pink-100 text-pink-400">
                    <thead>
                        <tr>
                            <th className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                S.No.
                            </th>
                            <th className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                UserId
                            </th>
                            <th className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                UserName
                            </th>
                            <th className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Email
                            </th>

                            <th className="h-12  px-16 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Image
                            </th>
                            <th className="h-12 px-16 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Title
                            </th>
                            <th className="h-12 px-10 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Price
                            </th>
                            <th className="h-12 px-10 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Category
                            </th>
                            <th className="h-12 px-10 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Date & time
                            </th>
                            <th className="h-12 px-10 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Edit
                            </th>
                            <th className="h-12 px-6 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Products
                            </th>

                            <th className="h-12 px-10 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Featured
                            </th>
                            <th className="h-12 px-10 text-md border-l first:border-l-0 border-pink-100 text-slate-700 bg-slate-100 font-bold">
                                Delete
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {getAllProduct.map((item, index) => {
                            const { id, userId, email, username, title, price, category, date,time, productImageUrl, approved, featured } = item;

                            const images = Array.isArray(productImageUrl)
                                ? productImageUrl
                                : productImageUrl ? [productImageUrl] : [];


                            return (
                                <tr key={index} className="text-pink-300">
                                    {/* S.No */}
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {index + 1}.
                                    </td>
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {userId}
                                    </td>
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {username}
                                    </td>
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {email}
                                    </td>
                                    {/* Product Image */}
                                    <td className="h-48   px-2 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {/* <div className="flex justify-center">
                                            <img className="w-24" src={productImageUrl} alt="" />
                                        </div> */}
                                        <div className="flex">
                                            {images?.slice(0, 1).map((url, i) => (
                                                <a href={url} target="_blank">
                                                    <img
                                                        key={i}
                                                        src={url}
                                                        alt="Product"
                                                        className=" h-44 object-cover "
                                                    /></a>
                                            ))}
                                        </div>
                                    </td>

                                    {/* Title */}
                                    <td className="h-12 px-2 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {title}
                                    </td>

                                    {/* Price */}
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        ₹{price}
                                    </td>

                                    {/* Category */}
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        {category}
                                    </td>

                                    {/* Date */}
                                    <td className="h-24  border border-pink-100 text-slate-500">
                                                {time ? time.toDate().toLocaleString('en-IN', {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                    second: '2-digit',
                                                    hour12: true,
                                                    timeZone: 'Asia/Kolkata'
                                                }) : 'N/A'}
                                            </td>

                                    {/* Edit Button */}
                                    <td
                                        onClick={() => navigate(`/updateproduct/${id}`)}
                                        className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-800 font-medium cursor-pointer"
                                    >
                                        Edit
                                    </td>

                                    {/* ✅ Approve Button */}
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        <button
                                            onClick={() => approveProduct(id, item)}
                                            disabled={approved}
                                            className={`w-full px-4 py-2 rounded-md ${approved
                                                    ? 'bg-gradient-gold text-black font-medium cursor-not-allowed'
                                                    : 'bg-blue-500 hover:bg-blue-600 text-white font-medium'
                                                }`}
                                        >
                                            {approved ? 'Approved' : 'Approve'}
                                        </button>
                                    </td>


                                    {/* ✅  Featured Button */}
                                    <td className="h-12 px-6 border-t border-l first:border-l-0 border-pink-100 text-slate-500">
                                        <button
                                            onClick={() => approveFeatured(id, item)}
                                            disabled={featured}
                                            className={`w-full px-4 py-2 rounded-md ${featured
                                                    ? 'bg-green-400 text-black font-medium cursor-not-allowed'
                                                    : 'bg-blue-500 hover:bg-blue-600 font-medium text-white'
                                                }`}
                                        >
                                            {featured ? 'Approved' : 'Approve '}
                                        </button>
                                    </td>
                                    {/* Delete Button */}

                                    <td
                                        onClick={() => deleteProduct(id)}
                                        className="h-12 px-6  border-t border-l first:border-l-0 border-pink-100 text-red-600 font-semibold cursor-pointer"
                                    >
                                        Delete
                                    </td>


                                </tr>
                            );
                        })}
                    </tbody>
                </table>

            </div>

            <style dangerouslySetInnerHTML={{ __html: "\n.hide-scroll-bar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.hide-scroll-bar::-webkit-scrollbar {\n  display: none;\n}\n" }} />

        </div>

    );
};

export default ProductDetails;
